import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import OrganizationHeader from './table-header.vue';
import OrganizationEdit from './edit.vue';
import FullScreen from '@blade/common/components/full-screen.vue';
import { OrganizationModule } from '@blade-sxp/account/store/organization';
import { handleError } from '@blade/common/utils/handle-error';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class default_1 extends Vue {
    value = '';
    list = [];
    selectOpts = [];
    currPage = 1;
    outerPageSize = 5;
    outerOpen = false;
    mode = 'ORGACREATE';
    DEFAULTPAGESIZE = 10;
    totalNum = 0;
    currId = '';
    listLoading = false;
    fullscreen = false;
    // get name() {
    //   return UserModule.name
    // }
    // get roles() {
    //   return UserModule.roles
    // }
    get showPagination() {
        return this.totalNum !== 0 && !this.listLoading;
    }
    mounted() {
        console.log('i18n:', this.$i18n);
        const routeQuery = this.$route.query;
        const pageNum = routeQuery?.pageNum;
        this.currPage = pageNum ? parseInt(pageNum) : 1;
        this.getData();
    }
    async getData() {
        this.listLoading = true;
        try {
            const res = await OrganizationModule.getOrganizations({
                page: this.currPage,
                size: this.outerPageSize,
            });
            this.list = res.org_vos;
            this.totalNum = res.total_size;
            this.listLoading = false;
        }
        catch (e) {
            handleError(e);
        }
        finally {
            this.listLoading = false;
        }
    }
    handleEdit(id) {
        this.mode = 'ORGAEDIT';
        this.outerOpen = true;
        this.currId = id;
    }
    handlePagination(value) {
        this.currPage = value;
        const pageNum = value.toString() || '1';
        const currParam = { pageNum };
        this.$router.replace({ path: '/users/organization', query: currParam });
    }
    handleSizeNavigation(value) {
        this.outerPageSize = value;
        this.handlePagination(1);
    }
    handleCreate() {
        this.mode = 'ORGACREATE';
        this.outerOpen = true;
    }
    handleClose() {
        this.outerOpen = false;
    }
    handleFullScreen() {
        if (!this.fullscreen) {
            document.body.requestFullscreen();
        }
        else {
            document.exitFullscreen();
        }
        this.fullscreen = !this.fullscreen;
    }
    handleRefresh() {
        console.log('refresh');
        this.getData();
    }
    handleSubmit(mode) {
        this.outerOpen = false;
        if (mode === 'ORGACREATE') {
            this.$elmessage.success(this.$t('successCreate').toString());
        }
        else {
            this.$elmessage.success(this.$t('successUpdate').toString());
        }
        this.getData();
    }
    handleDelete(id) {
        this.$confirm(`${this.$t('confirmDelete').toString()} ${id} ?`, 'Warning', {
            confirmButtonText: this.$t('ok').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: async (action) => {
                if (action === 'confirm') {
                    try {
                        await OrganizationModule.deleteOrganization(id);
                        this.getData();
                    }
                    catch (e) {
                        handleError(e);
                    }
                }
            },
        });
    }
    handleError(e) {
        this.outerOpen = false;
        this.$nextTick(() => this.$elmessage({ message: e.message, type: 'error' }));
    }
    onLocaleChange(newVal) {
        this.getData();
    }
    onRouteChange(to, from) {
        if (to && from && to.path === from.path) {
            this.getData();
        }
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], default_1.prototype, "onRouteChange", null);
default_1 = __decorate([
    Component({
        name: 'AccountList',
        components: {
            'organization-header': OrganizationHeader,
            OrganizationEdit,
            'full-screen': FullScreen,
            AuthItem,
        },
        i18n: {
            messages: {
                'en-us': {
                    account: 'Account',
                    name: 'Dept. Name',
                    code: 'Department Code',
                    member: 'Member',
                    upDept: 'Upper Dept.',
                    email: 'Email',
                    organization: 'Department',
                    status: 'Status',
                    createTime: 'Created Time',
                    daysLeft: 'Remaining Time',
                    actions: 'Operation',
                    edit: 'Edit',
                    delete: 'Delete',
                    successCreate: 'Successfully create organization',
                    successUpdate: 'Successfully update organization',
                    confirmDelete: 'Are you sure to delete organization',
                    ok: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    account: '账号',
                    name: '部门名称',
                    code: '部门编码',
                    member: '部门成员',
                    upDept: '上级部门',
                    email: '邮箱',
                    organization: '组织架构',
                    status: '状态',
                    createTime: '创建时间',
                    daysLeft: '剩余天数',
                    actions: '操作',
                    edit: '编辑',
                    delete: '删除',
                    successCreate: '成功创建组织',
                    successUpdate: '成功更新组织',
                    confirmDelete: '确认删除组织',
                    ok: '确认',
                    cancel: '取消',
                },
            },
        },
    })
], default_1);
export default default_1;
